var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto",attrs:{"draggable":""},on:{"dragstart":function($event){if($event.target !== $event.currentTarget)return null;return _vm.onDrag.apply(null, arguments)},"dragover":function($event){$event.preventDefault();},"dragenter":function($event){$event.preventDefault();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }